import { BiometricLoginModel, LoginModel, SecurityTokenModel } from '../models/AccountModels';
import { ApiResult } from '../models/ApiResult';
import { AuthenticationResult } from '../models/TwoFactorAuthenticationResult';
import { post } from './api/ApiWrapper';

export const loginWithCredentials = async (
	credentials: LoginModel
): Promise<ApiResult<SecurityTokenModel | string> | null> => {
	return post('api/authentication/credentials', credentials, null, false);
};

export const loginWithBiometric = async (
	biometricLoginModel: BiometricLoginModel
): Promise<ApiResult<AuthenticationResult | string> | null> => {
	return post('api/authentication/biometric', biometricLoginModel, null, false);
};
